import { queryOptions, skipToken } from '@tanstack/react-query'
import { IAuthContext } from './useAuth'
import { StorfeData } from '../types/types'
import { throwOnError } from '../utils/throwOnError'

export const getStorfeByIndividmerkeOptions = (
  auth: IAuthContext,
  individmerke: string
) => {
  return queryOptions({
    queryKey: ['husdyrregister/storfe', individmerke],
    queryFn:
      individmerke.length === 12
        ? async () => {
            const { data, error } = await auth
              .authFetch()
              .GET('/husdyrregister/storfe/{individmerke}', {
                params: {
                  path: {
                    individmerke
                  }
                }
              })
            if (error) {
              throwOnError(error)
            }
            return data as unknown as StorfeData
          }
        : skipToken
  })
}
